export var GET_ALL_SHIFTS = '[Shifts] Get All';
export var GET_ALL_SHIFTS_SUCCESS = '[Shifts] Get All Success';
export var GET_ALL_SHIFTS_ERROR = '[Shifts] Get All Error';
export var GET_SHIFT = '[Shifts] Get Shift';
export var GET_SHIFT_SUCCESS = '[Shifts] Get Shift Success';
export var GET_SHIFT_ERROR = '[Shifts] Get Shift Error';
export var ROTATE_SHIFT = '[Shifts] Rotate Shift';
export var ROTATE_SHIFT_SUCCESS = '[Shifts] Rotate Shift Success';
export var ROTATE_SHIFT_ERROR = '[Shifts] Rotate Shift Error';
var GetAllShifts = /** @class */ (function () {
    function GetAllShifts() {
        this.type = GET_ALL_SHIFTS;
    }
    return GetAllShifts;
}());
export { GetAllShifts };
var GetAllShiftsSuccess = /** @class */ (function () {
    function GetAllShiftsSuccess(payload) {
        this.payload = payload;
        this.type = GET_ALL_SHIFTS_SUCCESS;
    }
    return GetAllShiftsSuccess;
}());
export { GetAllShiftsSuccess };
var GetAllShiftsError = /** @class */ (function () {
    function GetAllShiftsError(payload) {
        this.payload = payload;
        this.type = GET_ALL_SHIFTS_ERROR;
    }
    return GetAllShiftsError;
}());
export { GetAllShiftsError };
var GetShift = /** @class */ (function () {
    function GetShift(payload) {
        this.payload = payload;
        this.type = GET_SHIFT;
    }
    return GetShift;
}());
export { GetShift };
var GetShiftSuccess = /** @class */ (function () {
    function GetShiftSuccess(payload) {
        this.payload = payload;
        this.type = GET_SHIFT_SUCCESS;
    }
    return GetShiftSuccess;
}());
export { GetShiftSuccess };
var GetShiftError = /** @class */ (function () {
    function GetShiftError(payload) {
        this.payload = payload;
        this.type = GET_SHIFT_ERROR;
    }
    return GetShiftError;
}());
export { GetShiftError };
var RotateShift = /** @class */ (function () {
    function RotateShift(payload) {
        this.payload = payload;
        this.type = ROTATE_SHIFT;
    }
    return RotateShift;
}());
export { RotateShift };
var RotateShiftSuccess = /** @class */ (function () {
    function RotateShiftSuccess(payload) {
        this.payload = payload;
        this.type = ROTATE_SHIFT_SUCCESS;
    }
    return RotateShiftSuccess;
}());
export { RotateShiftSuccess };
var RotateShiftError = /** @class */ (function () {
    function RotateShiftError(payload) {
        this.payload = payload;
        this.type = ROTATE_SHIFT_ERROR;
    }
    return RotateShiftError;
}());
export { RotateShiftError };



// WEBPACK FOOTER //
// /Users/Chetan/Downloads/angular5_admin-master/src/app/shifts/store/actions/shift.action.ts.pre-build-optimizer.js